/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, EventEmitter, Input, Output} from '@angular/core';

import {LotRemovalEvent, TenureRemovalEvent} from '../tenure.service';

@Component({
    selector: 'nlr-affected-tenure',
    imports: [],
    templateUrl: './affected-tenure.component.html',
    styleUrl: './affected-tenure.component.scss'
})
export class AffectedTenureComponent {
    @Input() summaryViewModel: any;
    @Input() dataLabelMap: any;
    @Input() removeTenureDisabled: boolean;
    @Input() removeLotDisabled: boolean = false;
    @Output() dataRemoveLot = new EventEmitter<LotRemovalEvent>();
    @Output() dataRemoveTenure = new EventEmitter<TenureRemovalEvent>();

    removeLot(tenureIndex: number, lotIndex: number): void {
        this.dataRemoveLot.emit({tenureIndex: tenureIndex, lotIndex: lotIndex});
    }

    removeTenure(tenureIndex: number): void {
        this.dataRemoveTenure.emit({tenureIndex: tenureIndex});
    }
}
